import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/sysFormMachinery/page',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/sysFormMachinery/saveOrUpdate',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/sysFormMachinery/detail/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/sysFormMachinery/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/sysFormMachinery/' + id,
method: 'put',
data: obj
})
}
